const React = require('react');

require('./protocol.scss');

const serviceProtocalUrl = 'https://s.keruyun.com/protocols/userService';
const privacyProtocalUrl = 'https://s.keruyun.com/protocols/privacy_p';

const KryProtocol = React.createClass({
  displayName: 'KryProtocol',
  propTypes: {
    type: React.PropTypes.string,
  },

  render() {
    const { type } = this.props;
    const userProtocal = sessionStorage.getItem('userProtocal');
    const privacyProtocal = sessionStorage.getItem('privacyProtocal');

    const url = type === 'service' ? userProtocal || serviceProtocalUrl : privacyProtocal || privacyProtocalUrl;
    const overflowStyle = navigator.userAgent.match(/android/i) ? 'hidden' : 'auto';

    return (
      <div className="protocol" style={{ 'overflow': overflowStyle }}>
        <iframe scrolling="auto" src={`${url}?lang=${sessionStorage.getItem('locale')}`} />
      </div>
    );
  },
});

module.exports = KryProtocol;



// WEBPACK FOOTER //
// ./src/component/user-login/kry-protocol.jsx